import equal from 'fast-deep-equal/react';
import styles from './CategoryTimer.scss';
import { t } from '~/utils/localization';
import { useDispatch, useSelector } from 'react-redux';
import { disableCategory } from '~/Actions/ActionApp';
import classNames from 'classnames';
import CountDown from '~/components/CountDown/CountDown';
import { State } from '~/Reducers';

interface ICategoryTimer {
    categoryName: string;
}

interface IStateSelector {
    categories: ICategories;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        categories: state.ReducerApp.categories,
    };
};

const CategoryTimer = (props: ICategoryTimer) => {
    const dispatch = useDispatch();
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const category = state.categories[props.categoryName];

    return (
        <div className={classNames(styles.wrapper, styles[category.theme])} key={category.name}>
            <div className={styles.title}>
                <span className={styles.label}>{t('До конца события')}</span>&nbsp;
            </div>
            <div className={styles.timer}>
                <CountDown
                    date={category?.activeTill}
                    isLarge={true}
                    onComplete={() => {
                        dispatch(disableCategory(props.categoryName));
                    }}
                />
            </div>
        </div>
    );
};

export default CategoryTimer;
